const initState = () => ({
  excludedIds: [],
})

export const MUTATIONS = {
  SET_EXCLUDED_IDS: 'SET_EXCLUDED_IDS',
  RESET_MEMORY: 'RESET_MEMORY',
}

export default {
  namespaced: true,
  state: initState(),
  getters: {
    excludedIds: (state) => state.excludedIds,
  },
  mutations: {
    [MUTATIONS.SET_EXCLUDED_IDS](state, id) {
      if (state.excludedIds.includes(id)) {
        state.excludedIds.splice(state.excludedIds.indexOf(id), 1)
      } else {
        state.excludedIds.push(id)
      }
    },
    [MUTATIONS.RESET_MEMORY](state) {
      state.excludedIds = [];
    }
  },
  actions: {
    
  }
}
